import React, { ChangeEvent, useContext, useState } from "react";
import ICatalog from "../../../models/ICatalog";
import IPrice_Group from "../../../models/IPrice_Group";
import IDashboardEntryItemUI from "../../../models/IDashboardEntryItemUI";
import OwLabel from "../../shared/OwLabel/OwLabel";
import ICatalog_Item from "../../../models/ICatalog_Item";
import UIService from "../../../services/UIService";
import { FormattedNumber } from "react-intl";
import SupplierContext from "../../../contexts/SupplierContext";
import { NumericFormat } from "react-number-format";
import UserContext from "../../../contexts/UserContext";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import * as _ from "lodash-es";

type Props = {
    catalog: ICatalog;
    priceGroup: IPrice_Group;
    dashboardEntryItems: IDashboardEntryItemUI[];
    getPricingValue: (item: ICatalog_Item) => number;
    setShippingValue: (value: number) => void;
};

export const DashboardItemEntryTotalsPanel = (props: Props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const isMainViewLight = UIService.isMainViewLight();

    const [shipping, setShipping] = useState(0);
    const [shippingEditMode, setShippingEditMode] = useState(false);
    const showSubTotal = _.get(supplierModel, "dashboard_entry_config.totalSection.isSubTotalsVisible", true);
    const showShipping = _.get(supplierModel, "dashboard_entry_config.totalSection.isShippingVisible", true);
    const showMsrpTotal = _.get(supplierModel, "dashboard_entry_config.totalSection.isMsrpTotalVisible", false);

    let subTotal = 0;
    let msrpGrandTotal = 0;

    props.dashboardEntryItems.forEach((item: IDashboardEntryItemUI) => {
        const price = !_.isNil(item.manual_price) ? item.manual_price : props.getPricingValue(item.Catalog_Item);

        if (price) {
            subTotal += price * item.qty;
        }

        const msrpPrice = item.msrp || item.Catalog_Item.msrp;

        if (msrpPrice) {
            msrpGrandTotal += msrpPrice * item.qty;
        }
    });

    const grandTotal = shipping + subTotal;

    const handleChange = (e: ChangeEvent<any>) => {
        setShipping(Number(e.target.value));
    };

    const saveShipping = () => {
        props.setShippingValue(shipping);
        setShippingEditMode(false);
    };

    return (
        <div className={"DashboardItemEntryTotalsPanel row justify-content-end"}>
            <div className={"col-2"}>
                <table className={"table table-striped " + (isMainViewLight ? "" : "table-dark")}>
                    <tbody>
                        {showSubTotal ? (
                            <tr>
                                <th>
                                    <OwLabel title={"sub_total"} postText={":"} />
                                </th>
                                <td className={"text-end"}>
                                    <NumericFormat
                                        value={subTotal}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        prefix={"$"}
                                    />
                                </td>
                            </tr>
                        ) : null}
                        {showShipping ? (
                            <tr>
                                <th>
                                    <OwLabel title={"shipping"} postText={":"} />
                                </th>
                                <td className={"text-end d-flex justify-content-end"}>
                                    {userModel.isSupplierUser ? (
                                        <span className={"me-2"}>
                                            {shippingEditMode ? (
                                                <span className={""}>
                                                    <i className={"fas fa-check text-success pointer me-2"} onClick={saveShipping} />
                                                    <i
                                                        className={"fas fa-times text-danger pointer"}
                                                        onClick={() => setShippingEditMode(false)}
                                                    />
                                                </span>
                                            ) : (
                                                <i
                                                    className={"fad fa-pencil text-primary pointer"}
                                                    onClick={() => setShippingEditMode(true)}
                                                />
                                            )}
                                        </span>
                                    ) : null}
                                    {shippingEditMode ? (
                                        <OwFnInput
                                            className={"d-inline-flex w-5r"}
                                            fn={handleChange}
                                            name={"shipping"}
                                            value={shipping}
                                            type={"number"}
                                            onWheelFn={(e) => e.preventDefault()}
                                        />
                                    ) : (
                                        <NumericFormat
                                            value={shipping}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                            prefix={"$"}
                                        />
                                    )}
                                </td>
                            </tr>
                        ) : null}
                        <tr>
                            <th>
                                <OwLabel title={"grand_total"} postText={":"} />
                            </th>
                            <td className={"text-end"}>
                                <NumericFormat
                                    value={grandTotal}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    prefix={"$"}
                                />
                            </td>
                        </tr>
                        {showMsrpTotal ? (
                            <tr>
                                <th>
                                    <OwLabel title={"msrp_grand_total"} postText={":"} />
                                </th>
                                <td className={"text-end"}>
                                    <NumericFormat
                                        value={msrpGrandTotal}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        prefix={"$"}
                                    />
                                </td>
                            </tr>
                        ) : null}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
